module.exports = __webpack_public_path__ + "static/media/blog28-3.04b47867.webp";